<div class="card-container-shadow tw-flex tw-flex-col tw-items-start md:tw-flex-row" #card>
  <div class="ingredient-container">
    <div class="options-container tw-hidden md:tw-flex" *ngIf="!editing">
      <div nz-popover="" nzPopoverTitle="" nzPopoverContent="Editar" class="icon-action" (click)="onEmitEditIngredient()">
        <i nz-icon nzType="edit" nzTheme="outline"></i>
      </div>
      <div nz-popover="" nzPopoverTitle="" nzPopoverContent="Eliminar" nzPopoverPlacement="bottom" class="icon-action danger" (click)="onEmitRemoveIngredient()">
        <i nz-icon nzType="delete" nzTheme="outline"></i>
      </div>
    </div>
    <div class="ingredient-info" [ngStyle]="{'color': color}">
      <p class="text text-info-bold truncate" nz-popover="" nzPopoverTitle="" [nzPopoverContent]="ingredient.ingredientName + ' | ' +
        ingredient.category?.name" nzPopoverMouseEnterDelay="0.3" [nzPopoverOrigin]="card">
        {{ ingredient.ingredientName }}
      </p>
      <div nz-row [nzGutter]="[15, 15]" class="macronutrients d-flex" *ngIf="!editing">
        <div nz-col [nzXs]="8" [nzMd]="3">
          <div class="macronutrient">
          <p class="text-info-bold-xs opacity-70">Calorías</p>
          <p class="text-info text-bold text-small">{{ ingredient.nutritionalProperties?.energy_kcal?.toFixed(2) || 0 }} kcal</p>
        </div>
        </div>
        <div nz-col nzXs="8" nzMd="3">
          <div class="macronutrient">
          <p class="text-info-bold-xs opacity-70">Grasas</p>
          <p class="text-info text-bold text-small">{{ ingredient.nutritionalProperties?.totalFat_g?.toFixed(2) || 0 }} g</p>
        </div>
        </div>
        <div nz-col nzXs="8" nzMd="3">
          <div class="macronutrient">
          <p class="text-info-bold-xs opacity-70">H.C</p>
          <p class="text-info text-bold text-small">{{ ingredient.nutritionalProperties?.carbohydrate_g?.toFixed(2) || 0 }} g</p>
        </div>
        </div>
        <div nz-col nzXs="8" nzMd="3">
          <div class="macronutrient">
          <p class="text-info-bold-xs opacity-70">Proteínas</p>
          <p class="text-info text-bold text-small">{{ ingredient.nutritionalProperties?.protein_g?.toFixed(2) || 0 }} g</p>
        </div>
        </div>
        <div nz-col nzXs="8" nzMd="3">
          <div class="macronutrient">
          <p class="text-info-bold-xs opacity-70">Fibra</p>
          <p class="text-info text-bold text-small">{{ ingredient.nutritionalProperties?.dietaryFiber_g?.toFixed(2) || 0 }} g</p>
        </div>
        </div>
        <div nz-col nzXs="8" nzMd="3">
          <div class="macronutrient">
          <p class="text-info-bold-xs opacity-70">Porción</p>
          <p class="text-info text-bold text-small">{{ ingredient.nutritionalProperties?.portions?.toFixed(2) }}</p>
        </div>
        </div>
        <div nz-col nzXs="8" nzMd="3" *ngIf="ingredient.unitOfMeasurement?._id !== ingredient.measure?._id">
          <div class="macronutrient"> <!-- Mostrar la unidad del ingrediente -->
          <p class="text-info-bold-xs opacity-70 truncate">{{ (ingredient.unitOfMeasurement?.name_es || ingredient.unitOfMeasurement?.name) + '(s)' }}</p>
          <p class="text-info text-bold text-small">{{ ingredient.nutritionalProperties?.measurementUnits }}</p>
        </div>
        </div>
        <div nz-col nzXs="8" nzMd="3" *ngIf="ingredient.unitOfMeasurement?._id === ingredient.measure?._id && ingredient.measure?.symbol_es !== 'g'">
          <div class="macronutrient">
          <!-- Mostrar en gramos -->
          <p class="text-info-bold-xs opacity-70 truncate">Gramo(s)</p>
          <p class="text-info text-bold text-small">{{ ingredient.nutritionalProperties?.grams }}</p>
        </div>
        </div>
      </div>
      <div class="tw-flex tw-items-start tw-gap-4 md:tw-hidden" *ngIf="!editing">
        <div nz-popover="" nzPopoverTitle="" nzPopoverContent="Editar" class="icon-action" (click)="onEmitEditIngredient()">
          <i nz-icon nzType="edit" nzTheme="outline" class="tw-mr-2"></i>
          <span>Editar</span>
        </div>
        <div nz-popover="" nzPopoverTitle="" nzPopoverContent="Eliminar" nzPopoverPlacement="bottom" class="icon-action danger" (click)="onEmitRemoveIngredient()">
          <i nz-icon nzType="delete" nzTheme="outline" class="tw-mr-2"></i>
          <span>Eliminar</span>
        </div>
      </div>
      <div class="loading-card" *ngIf="editing">
        <i nz-icon nzType="loading" nzTheme="outline"></i>
        <span>Editando...</span>
      </div>
    </div>
  </div>
  <div class="units-info" [ngStyle]="{'background-color': color}">
    <p class="text units text-info-bold">
      {{ ingredient.units }}
    </p>
    <p class="text text-info-sm truncate">
      {{ (ingredient.measure?.name || ingredient.measure?.name_es) + '(s)' }}
    </p>
  </div>
</div>
